import React, { useEffect, useState } from "react";
import { AlertCircle, CheckCircle2, X } from "lucide-react";
import { dismissToast, subscribeToToasts } from "../../utils/toast";

const toastStyles = {
  success: {
    container: "border-[#86EFAC] bg-[#F0FDF4] text-[#166534]",
    icon: "text-[#16A34A]",
  },
  error: {
    container: "border-[#FCA5A5] bg-[#FEF2F2] text-[#991B1B]",
    icon: "text-[#DC2626]",
  },
};

const ToastItem = ({ toast, onDismiss }) => {
  const styles = toastStyles[toast.type] || toastStyles.error;
  const Icon = toast.type === "success" ? CheckCircle2 : AlertCircle;

  return (
    <div
      role="alert"
      className={[
        "pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-xl border px-4 py-3 shadow-lg",
        styles.container,
      ].join(" ")}
    >
      <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${styles.icon}`} />
      <p className="flex-1 text-sm font-medium leading-5">{toast.message}</p>
      <button
        type="button"
        aria-label="Dismiss notification"
        onClick={() => onDismiss(toast.id)}
        className="shrink-0 rounded-full p-1 transition hover:bg-black/5"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    return subscribeToToasts((toast) => {
      if (toast.dismiss) {
        setToasts((current) => current.filter((item) => item.id !== toast.id));
        return;
      }

      setToasts((current) => [...current, toast]);
    });
  }, []);

  if (!toasts.length) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed right-4 top-4 z-[100] flex w-[min(100vw-2rem,24rem)] flex-col gap-3">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onDismiss={dismissToast} />
      ))}
    </div>
  );
};

export default ToastContainer;
